import { Modal } from './ui/Modal.jsx';
import { Icon } from './ui/Icon.jsx';
import { t } from '../i18n/index.js';

/** YouTube povezavo v vseh oblikah pretvori v vgradno. */
export function ytEmbedUrl(url) {
  if (!url) return null;
  const m =
    url.match(/[?&]v=([A-Za-z0-9_-]{6,})/) ??
    url.match(/youtu\.be\/([A-Za-z0-9_-]{6,})/) ??
    url.match(/youtube\.com\/shorts\/([A-Za-z0-9_-]{6,})/) ??
    url.match(/youtube\.com\/embed\/([A-Za-z0-9_-]{6,})/);
  return m ? `https://www.youtube.com/embed/${m[1]}` : null;
}

const SECTIONS = [
  ['zakaj', 'info', 'Zakaj to delamo'],
  ['kako', 'compass', 'Kako pravilno'],
  ['napake', 'alert', 'Pogoste napake'],
  ['varnost', 'award', 'Varnost'],
];

export function ExplanationModal({ title, subtitle, exp, onClose }) {
  const embed = ytEmbedUrl(exp?.video_url);

  return (
    <Modal eyebrow={subtitle} title={title} onClose={onClose}>
      <div className="stack stack--loose">
        {embed && (
          <div
            style={{
              position: 'relative',
              paddingBottom: '56.25%',
              borderRadius: 'var(--r-md)',
              overflow: 'hidden',
              background: '#000',
            }}
          >
            <iframe
              src={embed}
              title={`Video: ${title}`}
              style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', border: 0 }}
              allowFullScreen
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            />
          </div>
        )}

        {exp?.video_url && !embed && (
          <a
            href={exp.video_url}
            target="_blank"
            rel="noopener noreferrer"
            className="row t-sm t-bold"
            style={{ gap: 'var(--s-2)' }}
          >
            <Icon name="video" size={16} /> {t('Odpri video')}
          </a>
        )}

        {SECTIONS.filter(([k]) => exp?.[k]).map(([k, icon, label]) => (
          <section key={k}>
            <h4 className="row t-brand" style={{ marginBottom: 'var(--s-1)', gap: 'var(--s-2)' }}>
              <Icon name={icon} size={17} /> {t(label)}
            </h4>
            <p className="t-md" style={{ whiteSpace: 'pre-wrap' }}>
              {exp[k]}
            </p>
          </section>
        ))}

        {exp?.ucbenik_sklic && (
          <p className="card card--brand card--pad row t-sm t-brand" style={{ gap: 'var(--s-2)' }}>
            <Icon name="book" size={16} /> {t('Učbenik:')} {exp.ucbenik_sklic}
          </p>
        )}
      </div>
    </Modal>
  );
}
